var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigmaOriginal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_102_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 129C57.4 129 67 119.4 67 107.5V86H45.5C33.6 86 24 95.6 24 107.5C24 119.4 33.6 129 45.5 129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 64.5C24 52.6 33.6 43 45.5 43H67V86H45.5C33.6 86 24 76.4 24 64.5Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 21.5C24 9.6 33.6 0 45.5 0H67V43H45.5C33.6 43 24 33.4 24 21.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 0H88.5C100.4 0 110 9.6 110 21.5C110 33.4 100.4 43 88.5 43H67V0Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 64.5C110 76.4 100.4 86 88.5 86C76.6 86 67 76.4 67 64.5C67 52.6 76.6 43 88.5 43C100.4 43 110 52.6 110 64.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_102_39",
    x: -4,
    y: -4,
    width: 136,
    height: 137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_102_39"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_102_39",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaOriginal);
export default __webpack_public_path__ + "static/media/figma-original.0f7f48eeff63f575306cf8a70015c273.svg";
export { ForwardRef as ReactComponent };